import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ActivateOffer, CardLinkingQuery, CardLinkOffer, CardLinkOffersService, MemberQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Observable, Subject } from 'rxjs';
import { exhaustMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-card-link-offer-details',
  templateUrl: './card-link-offer-details.component.html',
  styleUrls: ['./card-link-offer-details.component.scss'],
})
export class CardLinkOfferDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('shopNowBtn', { static: false }) shopNowBtn: ElementRef;
  currentTab: string = 'description';
  @Input() cardLinkOfferDtail: CardLinkOffer;
  currentLcid: string;
  private _destroyed$ = new Subject<void>();
  @Input() clubImageUrl: string = '';
  cardLinkActivateOffer: ActivateOffer;
  selectedOffer: CardLinkOffer;
  modelContent: any;
  @ViewChild('cardNotLinkModal', { static: true }) cardNotLinkModal: ElementRef;

  constructor(
    private memberQuery: MemberQuery,
    private modalService: NgbModal,
    private cardLinkOffersService: CardLinkOffersService,
    private router: Router,
    private cardLinkingQuery: CardLinkingQuery
  ) {}

  ngOnInit(): void {
    this.currentLcid = this.memberQuery.getUserContext().lcid;
    /**
     * Dismiss external modals if any opened. This is for a fix when
     * returning to the portal from an external link offer.
     */
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll();
    }
  }

  /**
   * to prevent multiple calls
   * fromEvent will make click action to button string
   * and the in pipe exhaustMap will make the call to api for fatch url
   * and privent if user click multiple time
   * after subscription will check if url exist then move to url
   */
  ngAfterViewInit() {
    if (!this.shopNowBtn) {
      return;
    }

    fromEvent(this.shopNowBtn.nativeElement, 'click')
      .pipe(
        exhaustMap(() => this.fatchNavigationtoOfferUrl()),
        takeUntil(this._destroyed$)
      )
      .subscribe((activateOffer) => {
        this.cardLinkActivateOffer = activateOffer;
        if (activateOffer && activateOffer.ErrorNumber == 0) {
          this.openModel(this.modelContent);
          if (activateOffer.RedirectUrl.includes('http')) {
            setTimeout(() => {
              window.location.href = activateOffer.RedirectUrl;
            }, 3000);
          }
        }
      });
  }

  /**
   * fatch the URL from Navigation
   */
  fatchNavigationtoOfferUrl(): Observable<ActivateOffer> {
    return this.cardLinkOffersService.companiesClaim(this.selectedOffer.OfferId);
  }

  /**
   * open model to display the navigation progress
   * @param content to open the ngbModel to display the navigation progress
   */
  openModel(content: any) {
    this.modalService.open(content, { centered: true, windowClass: 'card-link-navigation-url-model-custom-size' });
  }

  /**
   * to activate the offer or warn user to link card
   * if no card found within the card linking store.
   * @param offer id
   */
  activateOffer(offerId: number) {
    this.cardLinkingQuery
      .selectCount()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((count) => {
        if (count > 0) {
          this.cardLinkOffersService.activateOffer(offerId).pipe(takeUntil(this._destroyed$)).subscribe();
        } else {
          this.modalService.open(this.cardNotLinkModal, { centered: true, ariaLabelledBy: 'modal-basic-title' });
        }
      });
  }

  /**
   * Unsubscribe the observables on distroy
   */
  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  /**
   * Will close the modal and navigate the user
   * to link their card.
   */
  linkCard(): void {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/linkcard');
  }
}
